import { X } from "lucide-react";
import { useConsent } from "@/consent/ConsentContext";
import { LEGAL_UPDATED } from "./legalContent";

export default function LegalPage({ title, sections, testid }) {
  const { openSettings } = useConsent();
  const close = () => {
    window.location.hash = "";
  };

  return (
    <div data-testid={testid} data-lenis-prevent className="fixed inset-0 z-[90] overflow-y-auto bg-white">
      <div className="mx-auto max-w-3xl px-6 pb-24 pt-10">
        <div className="flex items-center justify-between">
          <button
            data-testid={`${testid}-back`}
            onClick={close}
            className="f-mono text-[10px] tracking-[0.3em] text-slate-500 transition-colors hover:text-[#B8860B]"
          >
            &larr; ZUR&Uuml;CK ZUR WEBSITE
          </button>
          <button
            data-testid={`${testid}-close`}
            onClick={close}
            className="text-slate-400 transition-colors hover:text-slate-900"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <h1 className="f-display mt-10 text-4xl font-light tracking-tight text-slate-900 sm:text-5xl">
          {title}
        </h1>
        <p className="f-mono mt-3 text-[10px] tracking-[0.25em] text-slate-400">
          STAND: {LEGAL_UPDATED}
        </p>

        <div className="mt-12 space-y-10">
          {sections.map((s) => (
            <section key={s.h}>
              <h2 className="f-display text-2xl font-light tracking-tight text-slate-900">
                {s.h}
              </h2>
              <div className="mt-3 space-y-3">
                {s.p.map((para, i) => (
                  <p key={i} className="text-sm font-light leading-relaxed text-slate-600 sm:text-base">
                    {para}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-16 flex flex-wrap items-center gap-x-8 gap-y-3 border-t border-slate-200 pt-6">
          <a
            href="#/impressum"
            data-testid={`${testid}-impressum-link`}
            className="f-mono text-[10px] tracking-[0.25em] text-slate-500 transition-colors hover:text-[#B8860B]"
          >
            IMPRESSUM
          </a>
          <a
            href="#/datenschutz"
            data-testid={`${testid}-datenschutz-link`}
            className="f-mono text-[10px] tracking-[0.25em] text-slate-500 transition-colors hover:text-[#B8860B]"
          >
            DATENSCHUTZ
          </a>
          <button
            data-testid={`${testid}-cookie-settings-link`}
            onClick={openSettings}
            className="f-mono text-[10px] tracking-[0.25em] text-slate-500 transition-colors hover:text-[#B8860B]"
          >
            COOKIE-EINSTELLUNGEN
          </button>
        </div>
      </div>
    </div>
  );
}
